import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Chart } from "react-google-charts";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mobile: { minWidth: "1200px", height: "450px" },
    desktop: { minWidth: "100%" },
  })
);

export default function ChartBubble(propsBub: chartBubbleProps) {
  const styleGraphics = useStyles();

  return (
    <div className={window.screen.width < 1000 ? styleGraphics.mobile : styleGraphics.desktop}>
      <Chart
        // width={`${props.widthVal}px`}
        height="500px"
        chartType="BubbleChart"
        loader={
          <img
            height="150"
            width="150"
            src="https://mir-s3-cdn-cf.behance.net/project_modules/disp/35771931234507.564a1d2403b3a.gif"
            alt=""
          ></img>
        }
        data={propsBub.data}
        options={{
          title: propsBub.title,
          hAxis: { title: propsBub.hAxis },
          vAxis: { title: propsBub.vAxis },
          bubble: {
            textStyle: {
              fontSize: 12,
              fontName: "Times-Roman",
              color: "green",
              bold: true,
              italic: true,
              auraColor: "none",
            },
          },
        }}
        chartEvents={[
          {
            eventName: "ready",
            callback: ({ chartWrapper, props }) => {
              const chart = chartWrapper.getChart().getImageURI();
              propsBub.getImage(chart);
            },
          },
        ]}
        rootProps={{ "data-testid": "3" }}
      />
    </div>
  );
}

interface chartBubbleProps {
  data: any[];
  title: string;
  hAxis: string;
  vAxis: string;
  getImage(img: any): void;
}
